import { ProtectedRoute } from 'components/ui-routing/ProtectedRoute'
import { Navigate, RouteObject } from 'react-router-dom'
import { DataTab } from './data/DataTab'
import { SystemsTab } from './systems/SystemsTab'
import { TrackersTab } from './trackers/TrackersTab'
import { OverviewTab } from 'pages/dataSentry/overview/OverviewTab'
import { RoutesManager } from 'utils/routing/routesManager'
import { DataSentryContainer } from 'pages/dataSentry/dashboard/DataSentryContainer'
import { PERMISSIONS } from 'interfaces/permissions/permissions'

export const dataSentryRoutesChildren: RouteObject[] = [
  {
    path: RoutesManager.dataSentry.root.getURL(), // '/data-sentry'
    element: <ProtectedRoute component={DataSentryContainer} permissions={[PERMISSIONS.SENTRY_READ]} />,
    children: [
      {
        index: true,
        element: <Navigate to="overview" replace />,
      },
      {
        path: 'overview',
        element: <ProtectedRoute component={OverviewTab} permissions={[PERMISSIONS.SENTRY_READ]} />,
      },
      {
        path: 'systems',
        element: <ProtectedRoute component={SystemsTab} permissions={[PERMISSIONS.SENTRY_READ]} />,
      },
      {
        path: 'data',
        element: <ProtectedRoute component={DataTab} permissions={[PERMISSIONS.SENTRY_READ]} />,
      },
      {
        path: 'trackers',
        element: <ProtectedRoute component={TrackersTab} permissions={[PERMISSIONS.SENTRY_READ]} />,
      },
    ],
  },
]
